export const WAX = 'WAX';

export const RACOON = 'RACOON';
export const RACOON_ZEROS_AFTER_DOT = 4;

export const SDM = 'SDM';
export const SDM_ZEROS_AFTER_DOT = 4;
